/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import { Form, Button, Spin } from 'antd';
import { memo } from 'react';
import parser from 'html-react-parser';
import { decimalPlace } from '../../utils/helpers';
import { ISOToMDY } from '../../utils/date';
import DokanIcons from '../../components/icon/DokanIcons';

function WithdrawSummaryCard({
    preferences,
    antIcon,
    tiny_loader,
    withdrawBalance,
    lastApproved,
    openModal,
}) {
    return (
        <>
            {/** withdraw card */}
            <Spin indicator={antIcon} spinning={tiny_loader}>
                <div className="withdraw-summary-card md:justify-between md:items-center md:gap-0 md:flex-row flex-grow-1">
                    <div className="flex-grow-2">
                        <div className="flex flex-col gap-3">
                            <div className="font-semibold text-light_gray text-md">
                                Current Balance
                            </div>
                            <div className="font-extrabold text-dark text-xl">
                                {parser(preferences.currency_symbol || '')}
                                {withdrawBalance.current_balance || ''}
                                {`${parser(preferences.decimal_separator || '')}00`}
                            </div>
                            <div className="text-light_gray text-xs font-semibold">
                                Last payment
                                <span className="text-dark font-bold">
                                    {/** last withdraw should be an object */}
                                    &nbsp;
                                    {`${parser(preferences.currency_symbol || '')} ${decimalPlace(
                                        lastApproved.amount || '',
                                        2
                                    )}`}
                                    {}
                                </span>{' '}
                                approved in
                                <span className="text-dark font-bold"> {lastApproved.method} </span>
                                on {ISOToMDY(lastApproved.date)}
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-4">
                        <div className="flex flex-col gap-3 float-right">
                            <div className="">
                                <button
                                    type="button"
                                    className="m-2 py-3 px-6 bg-green-500 text-white rounded-md focus:outline-none"
                                    onClick={openModal}
                                >
                                    Withdraw now
                                </button>
                            </div>
                            <div className="flex justify-start items-start gap-2">
                                <div>
                                    <DokanIcons icon="#checkbox_info" size={3} />
                                </div>
                                <div className="text-light_gray text-sm font-normal">
                                    Minimum withdraw amount-{' '}
                                    {parser(preferences.currency_symbol || '')}
                                    {withdrawBalance.withdraw_limit}
                                </div>
                            </div>
                            <div className="flex justify-center items-center gap-2">
                                <div>
                                    <DokanIcons icon="#checkbox_info" size={3} />
                                    {/* <DokanIcons icon="#getway_peope" size={13} /> */}
                                </div>
                                <div className="text-light_gray text-sm font-normal">
                                    Withdraw Threshold- {withdrawBalance.withdraw_threshold} days
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Spin>

            {/** end withdraw card */}
        </>
    );
}
export default WithdrawSummaryCard;
